module.exports = __webpack_public_path__ + "static/media/ico-facebook-hover.386a3ff6.svg";